import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';
import { TextComponent } from '../components/text/text.component';
import { ButtonComponent } from '../components/button/button.component';
import { ImageComponent } from '../components/image/image.component';
import { VideoComponent } from '../components/video/video.component';
import { ButtonImageComponent } from '../components/buttom-image/button-image.component';
import {CarouselComponent} from "../components/carrousel-view/carousel/carousel.component";
import {ComponentEntity, TypeComponent} from "../../entities/component-entity";
import {S10Component} from "../components/S10/S10.component";

@Component({
  selector: 'lib-list-section-components',
  imports: [
    NgStyle,
    NgClass,
    TextComponent,
    ButtonComponent,
    ImageComponent,
    VideoComponent,
    ButtonImageComponent,
    CarouselComponent,
    S10Component,
  ],
  templateUrl: './list-section-components.component.html',
  styleUrl: './list-section-components.component.scss',
  standalone: true
})
export class ListSectionComponentsComponent {
  protected readonly TypeComponent = TypeComponent;

  @Input() components: ComponentEntity[] = [];
  @Input() sectionClass = '';
  @Input() backgroundColor: string | null = null;

  @Output() selected = new EventEmitter<ComponentEntity>();

  @Output() resizeHeight = new EventEmitter<{ newHeight: number; currently: number }>();

  onSelect(component: ComponentEntity) {
    this.selected.emit(component);
  }
}
